import React from 'react';
import styled from 'styled-components';
import ExperimentBucketing from '|/app/developer-control-panel/experiment-bucketing';
import FeatureBranches from '|/app/developer-control-panel/feature-branches';

const DebuggerContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 900;
`;

const DeveloperControlPanel = () => {
  return (
    <DebuggerContainer>
      <ExperimentBucketing />
      <FeatureBranches />
    </DebuggerContainer>
  );
};

export default DeveloperControlPanel;
